import React from "react";
import Layout from "../common/Layout";
import HeroSection from "../common/HeroSection";
import GalleryContent from "./GalleryContent";
import { getSEOData } from "../../utils/seo";

function GalleryTemplate() {
  const seoData = getSEOData("project-gallery");
  
  return (
    <Layout seoData={seoData}>
      <HeroSection title="Gallery" />
      <GalleryContent />
    </Layout>
  );
}

export default GalleryTemplate;
